// ============================================
// 🌐 STYLES CSS GLOBAUX
// ============================================

export const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;700&family=Outfit:wght@300;400;500;600;700&display=swap');
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: 'Outfit', sans-serif;
    background: #0a0f1c;
    color: #e4e4e7;
    min-height: 100vh;
    overflow-x: hidden;
  }

  html, body {
    max-width: 100%;
    overflow-x: hidden;
  }

  ::selection {
    background: #00D9FF;
    color: #0a0f1c;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #1a1f2e;
  }

  ::-webkit-scrollbar-thumb {
    background: #00D9FF;
    border-radius: 3px;
  }

  /* Touch targets pour mobile */
  button, a {
    min-height: 44px;
    min-width: 44px;
  }

  /* Focus styles pour accessibilité */
  input:focus, textarea:focus, button:focus {
    outline: 2px solid #00D9FF;
    outline-offset: 2px;
  }

  /* Animations */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  /* Utilitaires */
  .animate-fadeInUp {
    animation: fadeInUp 0.5s ease;
  }

  .animate-fadeIn {
    animation: fadeIn 0.3s ease;
  }

  /* Safe area pour iPhones avec encoche */
  @supports (padding: max(0px)) {
    body {
      padding-left: env(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
    }
  }

  /* Désactiver le highlight sur tap mobile */
  button {
    -webkit-tap-highlight-color: transparent;
    user-select: none;
  }
`;
